import { Box } from "@mui/material";
import { GridRowParams } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useGetPermissionsQuery } from "src/shared/api/rbac/rbac";
import { TablePage } from "src/shared/components/Table";
import { companiesTabsOptions } from "src/shared/constants/companiesTabs.constants";
import { useGetReportsQuery } from "src/shared/hooks/reports/reports.hooks";
import { useGetSummaryReportsListQuery } from "../model/api/api";
import { useGetTableColumns } from "../model/hooks/useGetTableColumns";
import { EBonusState, ISummaryReportItem } from "../model/types";
import { TableHeader } from "./TableHeader";

export function SummaryReport() {
  const [partnerName, setPartnerName] = useState("");
  const {
    query,
    filters,
    onPaginationModelChange,
    onSearch,
    onResetFilter,
    onFilter,
    activeTab,
    setActiveTab,
  } = useGetReportsQuery({
    partnerName,
    isSummaryReport: true,
  });

  const { data, isFetching } = useGetSummaryReportsListQuery(query);
  const { data: permissionData } = useGetPermissionsQuery(undefined);
  const allowedAgencies = permissionData?.data?.allowed_agencies;

  const {
    columns,
    noteModal,
    deleteNoteConfirmModal,
    editBonusDrawer,
    tableCheckedState,
    tableEmailsCheckedState,
    resetTableCheckedState,
    resetTableCheckedEmailsState,
  } = useGetTableColumns(data?.data);

  // here we trigger pull partners to show full name in the filter 'partner_id'
  useEffect(() => {
    if (query.partner_id && data?.data?.length) {
      const row = data.data.find(
        (r) => String(r.partner.id) === String(query.partner_id),
      );
      if (row) setPartnerName(row.partner.name);
    } else {
      setPartnerName("");
    }
  }, [data?.data, query.partner_id]);

  return (
    <Box
      sx={{
        height: "100%",
      }}
    >
      {noteModal}
      {editBonusDrawer}
      {deleteNoteConfirmModal}
      <TablePage<ISummaryReportItem>
        getRowClassName={(params: GridRowParams<ISummaryReportItem>) =>
          `row-${params.row.state}`
        }
        sx={{
          [`.row-${EBonusState.CHECKED}, .row-${EBonusState.ACT_FORMED}`]: {
            backgroundColor: "grey.50",
          },
        }}
        handleTabsChange={setActiveTab}
        localeText={{ noRowsLabel: "Нет данных за выбранный период" }}
        tabsValue={activeTab}
        tabsOptions={companiesTabsOptions}
        loading={isFetching}
        disableTablePageHeader={isFetching}
        disableColumnSelector
        allowedAgencies={allowedAgencies}
        title={
          <TableHeader
            resetTableCheckedState={resetTableCheckedState}
            resetEmailsCheckedState={resetTableCheckedEmailsState}
            rows={data?.data || []}
            tableCheckedState={tableCheckedState}
            tableEmailsCheckedState={tableEmailsCheckedState}
          />
        }
        tableSearchModel={{
          value: query.search || "",
          onSearch,
        }}
        tableFilterModel={{
          onReset: () =>
            onResetFilter([
              "partner_id",
              "agency",
              "service",
              "report_month",
              "states",
            ]),
          onFilter,
          filters: filters,
        }}
        rowCount={data?.meta.total || 0}
        paginationMode="server"
        columns={columns}
        paginationModel={{
          page: query.page ? Number(query.page) - 1 : 0,
          pageSize: query.per_page ? Number(query.per_page) : 25,
        }}
        onPaginationModelChange={onPaginationModelChange}
        rows={data?.data}
        disableRowSelectionOnClick
        getRowId={(row) => row.id}
      />
    </Box>
  );
}
